import React from 'react'
import { Formik, Form} from 'formik'
import * as Yup from 'yup'
import '../Styles/Register.css'
import { FaFacebook, FaGooglePlusG, FaTwitter } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import FormControl from '../Form/FormControl'

 const userInfo = {
        fullname: '',
        email: '',
        password: '',
        confirmPassword: ''
    }
    
    const onSubmit = values  => {
        console.log('New User', values)
    } 
    
    const registrationSchema = Yup.object({
        fullname: Yup.string()
            .required('Required!'),

            email: Yup.string()
                .email('Invalid mail Format')
                    .required('Required!'),

        password: Yup.string()
            .required('No password provided.') 
                .min(8, 'Password is too short - should be 8 chars minimum.')
                    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),

        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
    })



const Register = () => {
   

    return (
        <div className='register-container'>
            <div className="form">
            <div className="heading">
                    <h2 className="head">
                        Welcome!!!
                    </h2>
                    <p className="text">
                        Join us and get answers & homework done within minutes
                    </p>
                </div>
                <Formik 
                initialValues={userInfo}
                validationSchema={registrationSchema}
                onSubmit={onSubmit}>

                    {formik => (
                        <Form>

                            <FormControl
                                control='input'
                                    type='text'
                                        label='Fullname'
                                            name='fullname'
                                            placeholder='Full Name ...'/>

                            <FormControl
                                control='input'
                                    type='email'
                                        label='Email'
                                            name='email'
                                            placeholder='Email ...'/>

                            <FormControl
                                control='input'
                                    type='password'
                                        label='Password'
                                            name='password'
                                            placeholder='Paswword ...'/>

                            <FormControl
                                control='input'
                                    type='password'
                                        label='Password'
                                            name='confirmPassword'
                                            placeholder='Confirm Paswword ...'/>

                            

                            


                            <button type='submit' className='submit'>Submit</button>
                        </Form>
                    )}

                </Formik>

                <div className="alternate">
                            <p className="line-break">
                                or
                            </p>

                            <div className="social-tabs">
                            <button className="google social">
                                    <FaGooglePlusG className='icon'/>
                                    <span className="text">
                                        Google
                                    </span>
                                </button>
                                <button className="facebook social">
                                    <FaFacebook className='icon'/>
                                    <span className="text">
                                        Facebook
                                    </span>
                                </button>
                                <button className="twitter social">
                                    <FaTwitter className='icon'/>
                                    <span className="text">
                                        Twitter
                                    </span>
                                </button>
                            </div>
                </div>

                    <p>
                        Already have an Account?  
                        <Link to='/SignIn' className='sign-in'>
                             Sign In
                        </Link>
                    </p>
                    
           </div>
        </div>
    )
}

export default Register
